import { handleError } from 'globals/errors';
import { updateCurrentCustomer } from 'core_main/api/customers';
import { getStore } from 'core_main/store';
// eslint-disable-next-line import/no-cycle
import { rekeyRealtimeToCustomer } from 'core_main/pubnub/helpers/rekeyRealtime';
import { DescribeCustomerParameters } from './types';
import {
  formatAttributes,
  createDescribeCustomerCallbackResponse,
} from './helpers';

export const describeCustomer = (
  parameters: DescribeCustomerParameters,
  cb,
) => {
  const formattedAttributes = formatAttributes(parameters.attributes);

  const requestParams = {
    attributes: formattedAttributes,
    custom: parameters.customAttributes,
  };

  return updateCurrentCustomer(requestParams)
    .then((res) => {
      const callbackResponse = createDescribeCustomerCallbackResponse(res);
      const previousCustomerId = getStore().customerId;
      const nextCustomerId = callbackResponse?.customerId;

      // Email/identify can resolve the tracking customer to a survivor before
      // session.update arrives — re-key immediately to shrink the A→B gap.
      if (
        previousCustomerId &&
        nextCustomerId &&
        previousCustomerId !== nextCustomerId
      ) {
        rekeyRealtimeToCustomer(nextCustomerId, {
          source: 'event',
          fromCustomerId: previousCustomerId,
        }).catch((rekeyError) => {
          handleError(rekeyError, {
            message:
              'Failed to re-key realtime after describeCustomer identity change',
          });
        });
      }

      if (typeof cb === 'function') cb(callbackResponse);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: `Failed to describe customer:` });
    });
};
